import React, { useState, useEffect } from 'react';
import api from '../api';
import toast, { Toaster } from 'react-hot-toast';

export default function UserBalance() {
  const [wallets, setWallets] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(0);
  const [showTransfer, setShowTransfer] = useState(null);
  const [transferAmount, setTransferAmount] = useState('');

  useEffect(() => { loadData(); }, [refresh]);

  const loadData = () => {
    setLoading(true);
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = userData.id || 1;
    Promise.all([
      api.get('/auth/my-wallets?user_id=' + userId),
      api.get('/accounts')
    ]).then(([wRes, aRes]) => {
      setWallets(wRes.data);
      setAccounts(aRes.data);
      setLoading(false);
    }).catch(err => { console.error(err); setLoading(false); });
  };

  const submitTransfer = (e) => {
    e.preventDefault();
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    if (!transferAmount || transferAmount <= 0) return toast.error('Enter amount');
    
    // Find matching account (cash→cash, bank→bank)
    const matchingAccount = accounts.find(a => a.type === showTransfer.type);
    if (!matchingAccount) return toast.error('No ' + showTransfer.type + ' account found');
    if (parseFloat(transferAmount) > showTransfer.balance) return toast.error('Insufficient balance');

    api.post('/auth/collection-request', {
      user_id: userData.id,
      amount: parseFloat(transferAmount),
      account_id: matchingAccount.id,
      notes: 'Transfer from ' + showTransfer.type + ' wallet'
    }).then(() => {
      toast.success('Transfer request submitted!');
      setShowTransfer(null); setTransferAmount('');
      setRefresh(r => r + 1);
    }).catch(err => toast.error(err.response?.data?.error || 'Failed'));
  };

  const fmt = (n) => '₹' + (n || 0).toLocaleString('en-IN');

  if (loading) return <div style={{ textAlign: 'center', padding: 60, fontSize: 18 }}>Loading wallets...</div>;

  return (
    <div>
      <Toaster position="top-right" />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24, alignItems: 'center' }}>
        <h2 style={{ fontSize: 24, fontWeight: 'bold', margin: 0 }}>My Balance</h2>
        <button onClick={() => setRefresh(r => r + 1)} style={{ background: '#f3f4f6', border: 'none', padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>🔄 Refresh</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 16 }}>
        {wallets.map(w => (
          <div key={w.type} style={{ background: 'white', borderRadius: 12, padding: 24, boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderTop: '4px solid ' + (w.type === 'cash' ? '#16a34a' : '#2563eb') }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ fontSize: 20, fontWeight: 600, textTransform: 'capitalize', margin: 0 }}>{w.type} Wallet</h3>
              <span style={{ fontSize: 36 }}>{w.type === 'cash' ? '💵' : '🏦'}</span>
            </div>
            <p style={{ fontSize: 36, fontWeight: 'bold', color: w.balance > 0 ? '#16a34a' : '#6b7280', margin: '0 0 16px 0' }}>{fmt(w.balance)}</p>
            <button 
              onClick={() => { setShowTransfer(w); setTransferAmount(''); }}
              disabled={w.balance <= 0}
              style={{ width: '100%', padding: '10px 0', background: w.balance > 0 ? '#7c3aed' : '#d1d5db', color: 'white', border: 'none', borderRadius: 8, cursor: w.balance > 0 ? 'pointer' : 'default', fontWeight: 500, fontSize: 14 }}
            >
              Transfer to Company {w.type === 'cash' ? 'Cash' : 'Bank'}
            </button>
          </div>
        ))}
      </div>

      {showTransfer && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div style={{ background: 'white', borderRadius: 12, padding: 24, width: '100%', maxWidth: 400 }}>
            <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Transfer {showTransfer.type} Wallet</h3>
            <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 16 }}>Balance: {fmt(showTransfer.balance)} → Company {showTransfer.type} Account</p>
            <form onSubmit={submitTransfer}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 4 }}>Amount *</label>
                <input type="number" value={transferAmount} onChange={e => setTransferAmount(e.target.value)} required min="1" max={showTransfer.balance} style={{ width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 6, boxSizing: 'border-box', fontSize: 16 }} autoFocus />
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button type="submit" style={{ flex: 1, padding: 10, background: '#7c3aed', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 500 }}>Submit Request</button>
                <button type="button" onClick={() => setShowTransfer(null)} style={{ flex: 1, padding: 10, background: '#e5e7eb', border: 'none', borderRadius: 6, cursor: 'pointer' }}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
